export default [
    {
        name: 'anchor',
        sortField: 'anchor',
        type: 'string',
        useInFilter: true,
        isDefault: true,
        defaultSearch: true,
    },
    {
        name: 'link_type',
        sortField: 'link_type',
        type: 'link_type',
        callback: 'linkType',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'words_count',
        sortField: 'words_count',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:backlinks_count_for_anchor',
        sortField: 'backlinks_count',
        type: 'number',
        useInFilter: true,
    },
    {
        name: 'rel_types',
        sortField: 'rel_types',
        type: 'rel_type',
        defaultValue: () => [],
        callback: 'linkRelType',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'statuses',
        sortField: 'statuses',
        callback: 'linkStatuses',
        type: 'link_statuses',
        defaultSearch: false,
        useInFilter: true,
    }
]
